import { authSelectors } from 'ducks/auth'
import { FC, useEffect, useMemo, useState } from 'react'
import { AutocompleteInput } from 'react-admin'
import { useSelector } from 'react-redux'
import restClient from 'restClient'

interface PropTypes {
  fieldId: string
  source: string
}

const restClientInstance = restClient(window.API_ROOT + '/api')

const BrandFilter: FC<PropTypes> = ({ source, fieldId }) => {
  const orgId = useSelector(authSelectors.getOrgId)
  const [choices, setChoices] = useState<{ id: string; name: string }[]>([])
  const [searchedValue, setSearchedValue] = useState('')

  const filteredChoices = useMemo(() => {
    if (!searchedValue.trim()) return choices
    const q = searchedValue.toLowerCase()
    return choices.filter((c) => c.name.toLowerCase().includes(q))
  }, [choices, searchedValue])

  useEffect(() => {
    if (!orgId) return
    setSearchedValue('')
    const fetchBrands = async () => {
      try {
        const { data } = (await restClientInstance('CUSTOM_GET', 'custom', {
          url: `orgs/${orgId}/project_brands/`,
        })) as { data: string[] }
        setChoices(data.map((brand) => ({ id: brand, name: brand })))
      } catch {
        setChoices([])
      }
    }
    fetchBrands()
  }, [orgId])

  return (
    <AutocompleteInput
      choices={filteredChoices}
      source={`${source}.value.${fieldId}`}
      optionText="name"
      optionValue="id"
      variant="outlined"
      margin="none"
      label={false}
      allowDuplicates
      setFilter={(value) => setSearchedValue(value ?? '')}
    />
  )
}

export default BrandFilter
